<script>
import { mapState, mapActions } from 'vuex';
import { orderBy } from 'lodash';

export default {
  props: ['value'],
  data() {
    return {
      sending: false,
      header: '',
      maxNameLength: 30,
    };
  },
  computed: {
    ...mapState('votesResults', {
      avgResultList: (state) => orderBy(state.avgResultList, [(res) => res.name.toLowerCase()]),
    }),
  },
  methods: {
    ...mapActions('votesResults', ['getAverageList']),
    close() {
      this.$parent.close([null]);
    },
    trimName(name) {
      return name.length > this.maxNameLength ? `${name.substring(0, this.maxNameLength)}...` : name;
    },
  },
  created() {
    switch (this.value.activeTab) {
      case 'scoreByOperators':
        this.getAverageList({ key: this.value.activeTab, value: this.value.content.id });
        this.header = 'T_AVERAGE_OPERATOR_RATINGS_FOR_EACH_SKILL';
        break;
      case 'scoreByRequestTypes':
        this.getAverageList({ key: this.value.activeTab, value: this.value.content.id });
        this.header = 'T_AVERAGE_OPERATOR_RATINGS_FOR_EACH_TYPE_REQUEST';
        break;
      case 'scoreByChannels':
        this.getAverageList({ key: this.value.activeTab, value: this.value.content.identifier });
        this.header = 'T_AVERAGE_OPERATOR_RATINGS_FOR_EACH_CHANNEL';
        break;
      default:
        break;
    }
  },
};
</script>

<template lang="pug">
div(:class="$style.root")
  header(:class="$style.header")
    div(:class="$style.headerTitle") {{ $t(header) }}
  div(:class="$style.content")
    div(v-for="avgResult in avgResultList",
      :class="[$style.avgResult, avgResult.avgVote =='-' && $style.avgResultDisabled]")
      div(:class="$style.avgResultLabel", :title="avgResult.name") {{ trimName(avgResult.name) }}
      div(:class="$style.avgResultCount") {{ avgResult.avgVote }}
</template>

<style lang="sass" module>
.root
  display: block
.avgResultLabel
  cursor: pointer
.header
  padding: 24px
  border-bottom: 1px solid $color_divider
  &Title
    font-size: 18px
    display: flex
    justify-content: center
.content
  padding: 24px
  min-width: 532px
  max-height: 700px
  overflow: auto
.avgResult
  display: flex
  align-items: stretch
  line-height: 18px
  transition: color $a_speed
  & + &
    margin-top: 16px
  &Disabled
    color: $color_text_second
  &Label
    width: 188px
    overflow: hidden
    text-overflow: ellipsis
    font-size: 16px
    margin-right: 24px
    vertical-align: baseline
  &Count
    margin-left: 8px
    font-size: 16px
    font-weight: bold
    vertical-align: baseline
    white-space: nowrap
    display: flex
    justify-content: center
    flex-grow: 1

</style>
